import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/materials',
    name: 'POST_MATERIALS',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
